/** @jsxImportSource @emotion/react */
import { css, CSSObject } from "@emotion/react";

import { colors, Colors } from "@dotnet/telematics-design-system";

interface SeparatorProps {
  customStyle?: CSSObject;
  color?: Colors[keyof Colors];
  [key: string]: any;
}

const Separator = ({ customStyle, color, light, ...props }: SeparatorProps) => {
  return (
    <div
      {...props}
      data-testid="separator"
      css={css({
        height: "1px",
        background: color || colors.gray300,
        ...customStyle
      })}
    />
  );
};

export default Separator;
